import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

// Giant interactive name list; hovering crossfades the full-bleed background.
const InteractivePortfolio = ({ projects }) => {
  const { t, lp } = useLang();
  const [active, setActive] = useState(projects[0]?.slug);

  return (
    <section className="relative py-24 md:py-40 overflow-hidden" data-testid="interactive-portfolio">
      {projects.map((p) => (
        <div
          key={p.slug}
          className="absolute inset-0 transition-opacity duration-[900ms] ease-out"
          style={{ opacity: active === p.slug ? 0.4 : 0 }}
        >
          <img src={p.image} alt="" className="w-full h-full object-cover scale-105" />
        </div>
      ))}
      <div className="absolute inset-0 bg-ink/75" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <p className="font-display text-xs font-bold uppercase tracking-[0.3em] text-brand-gold mb-12">
          {t({ es: "Trabajos seleccionados", en: "Selected work" })}
        </p>
        <div className="border-t border-white/10">
          {projects.map((p, i) => (
            <Link
              key={p.slug}
              to={lp(`/proyectos/${p.slug}`)}
              onMouseEnter={() => setActive(p.slug)}
              onFocus={() => setActive(p.slug)}
              data-testid={`portfolio-item-${p.slug}`}
              className="group flex items-center justify-between gap-6 border-b border-white/10 py-5 md:py-7"
            >
              <div className="flex items-baseline gap-4 md:gap-8 min-w-0">
                <span className="font-display text-sm md:text-base font-bold text-white/25 group-hover:text-brand-gold transition-colors shrink-0">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-display font-black uppercase leading-none truncate text-3xl md:text-6xl lg:text-7xl text-white/45 group-hover:text-white transition-colors duration-300">
                  {p.title}
                </h3>
              </div>
              <span className="hidden sm:block font-display text-[0.7rem] md:text-xs font-bold uppercase tracking-[0.2em] text-white/40 group-hover:text-brand-gold transition-colors shrink-0">
                {t(p.kicker)}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InteractivePortfolio;
